import React, {useRef} from "react";
import {Modal, Form, Button, Input} from "antd";

const formLayout = {
    labelCol: {span: 5},
    wrapperCol: {span: 19},
};

function AccountBindModal({
    onClose,
    onOk,
}) {
    const formRef = useRef();
    const handleOk = async () => {
        const values = await formRef.current.validateFields();
        onOk(values);
    };

    return (
        <Modal
            open
            width={440}
            title={<div style={{textAlign: "center"}}>绑定账号</div>}
            bodyStyle={{
                padding: "24px 42px",
            }}
            footer={(
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <div style={{flex: 1}} />
                    <Button
                        onClick={onClose}
                        style={{
                            width: 120,
                            marginRight: 12,
                        }}
                    >
                        取消
                    </Button>
                    <Button
                        onClick={handleOk}
                        style={{
                            width: 120,
                            background: "#0084ff",
                            color: "#FFF",
                        }}
                    >
                        绑定
                    </Button>
                </div>
            )}
        
        >
            <Form
                ref={formRef}
                colon={false}
                requiredMark={false}
                {...formLayout}
            >
                <Form.Item
                    name="idCardNo"
                    label="身份证/账号"
                    rules={[{required: true, message: "请输入身份证/账号"}]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="userName"
                    label="姓名"
                    rules={[{required: true, message: "请输入姓名"}]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default AccountBindModal;
